import React from 'react'


const TabPanel = ({
    id,
    labelledby,
    isExpanded = false,
    children
})  => {
    const styles = {
        display: isExpanded ? 'block' : 'none'
    }

    return (
        <div
            id={id}
            className="access-tabpanel"
            role="tabpanel"
            aria-labelledby={labelledby}
            style={styles}
        >
            {children}
        </div>
    )
}

export default TabPanel